<div class="login-body">
    <div class="login-panel ui-fluid">
        <!-- <p-toast [style]="{marginTop: '80px'}"></p-toast> -->
        <!-- <div class="login-panel-header">
            <img src="assets/layout/images/login/datasense-logo-transparent.png">
        </div> -->
        <div class="login-panel-content p-p-4" (keydown)="onKeydown($event)">
            <div class="ui-g">
                <div class="ui-g-12 p-text-center">
                    <img src="assets/images/datasense-logo-transparent.png">
                </div>
                <div class="ui-g-12">
                    <h1>DataSense.BI Controller</h1>
                </div>
                <div class="ui-g-12">
                    <div class="ui-float-label">
                        <input id="username" class="p-p-2 ui-inputtext ui-corner-all ui-state-default ui-widget ng-valid ui-state-filled ng-dirty ng-touched" type="text" pInputText [(ngModel)]="korisnik">
                        <label for="username" style="top: -.75em; font-size: 12px;">Username</label>
                    </div>
                </div>
                <div class="ui-g-12">
                    <span class="ui-float-label">
                        <input id="password" class="p-p-2 ui-inputtext ui-corner-all ui-state-default ui-widget ng-valid ui-state-filled ng-dirty ng-touched" type="password" [feedback]="false" pPassword [(ngModel)]="zaporka">
                        <label for="password" style="top: -.75em; font-size: 12px;">Password</label>
                    </span>
                </div>
                <div class="ui-g-12 p-text-center">
                    <div class="ui-g-12">
                        <p-progressSpinner  *ngIf="this.isLoading" >Loading</p-progressSpinner>
                    </div>
                    <button pButton label="Log in" (click)="loginClick()" class="ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"></button>
                </div>
            </div>
        </div>
    </div>
</div>


